import { useEffect, useRef } from 'react'

import { ChatComposer } from '@/components/chat/ChatComposer'
import { MessageBubble } from '@/components/chat/MessageBubble'
import { Button } from '@/components/ui/Button'
import { Card } from '@/components/ui/Card'
import { useChatStore } from '@/store/chat'

const SUGGESTIONS = [
  '800kVA 干式变压器有哪些可选型号，能效和交期如何',
  '对比螺杆空压机 GA55A 与同功率机型的能耗',
  'DN200 气动蝶阀的现货与起订量',
  '列出 500kW 柴油发电机组的供应商与资质要求',
]

export function QueryPanel() {
  const messages = useChatStore((s) => s.messages)
  const status = useChatStore((s) => s.status)
  const error = useChatStore((s) => s.error)
  const send = useChatStore((s) => s.send)
  const stop = useChatStore((s) => s.stop)
  const reset = useChatStore((s) => s.reset)
  const bottom = useRef<HTMLDivElement>(null)

  useEffect(() => {
    bottom.current?.scrollIntoView({ block: 'end' })
  }, [messages])

  return (
    <Card
      title="AI 设备查询"
      subtitle="按参数、用途、预算提问"
      className="h-full"
      bodyClassName="flex flex-col min-h-0"
      actions={
        messages.length > 0 && (
          <Button size="sm" onClick={reset}>
            新查询
          </Button>
        )
      }
    >
      <div className="min-h-0 flex-1 overflow-y-auto p-3">
        {messages.length === 0 ? (
          <div className="flex flex-col gap-2.5">
            <p className="text-xs font-medium text-muted">试试这些查询</p>
            {SUGGESTIONS.map((s) => (
              <button
                key={s}
                type="button"
                onClick={() => send(s)}
                className="rounded-control border border-line bg-surface px-3 py-2 text-left text-[13px] text-ink transition-colors hover:border-brand-300 hover:bg-brand-50"
              >
                {s}
              </button>
            ))}
          </div>
        ) : (
          <div className="flex flex-col gap-3">
            {messages
              .filter((m) => m.content || m.streaming)
              .map((m) => (
                <MessageBubble key={m.id} message={m} />
              ))}
          </div>
        )}

        {error && (
          <p className="mt-3 rounded-control border border-danger/25 bg-danger-soft px-3 py-2 text-[13px] text-danger">
            {error}
          </p>
        )}
        <div ref={bottom} />
      </div>

      <ChatComposer busy={status === 'sending'} onSubmit={send} onStop={stop} />
    </Card>
  )
}
